import { Scholarship, SEO, PageLayout } from "../components";

const ScholarshipPage = () => {
  return (
     <>
     <SEO
      url="/scholarship"
      openGraphType="website"
      schemaType="website"
      title="Refresher Course Page"
      description="We help you transition into tech seamlessly." />
      <Scholarship />
      <PageLayout />
    </>
  );
};

export default ScholarshipPage;